import { DOCTYPES } from '@/constants/doctypes'
import { PERMISSIONS } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeMarketingDashboardHome, root: routeMarketingDashboardRoot } =
  createSingleViewRoutes({
    doctypes: {
      [DOCTYPES.EMAIL_GROUP]: [PERMISSIONS.READ],
      [DOCTYPES.EMAIL_GROUP_MEMBER]: [PERMISSIONS.READ],
    },
    name: 'marketing-dashboard',
    path: 'dashboard',
    view: async () => await import('@/components/views/marketing/MarketingDashboard.vue'),
  })

export { routeMarketingDashboardHome, routeMarketingDashboardRoot }
